/**
 * Runs `callback` once, on the first user interaction or after `fallbackMs`, whichever comes first.
 * Used to keep third-party scripts (analytics, chat) off the critical path: they were a large part
 * of the unused JavaScript and main-thread time measured by Lighthouse. No-op on the server.
 */
export function runOnFirstInteraction(callback: () => void, fallbackMs = 5000): void {
  if (typeof window === 'undefined') return;

  const events = ['pointerdown', 'keydown', 'touchstart', 'scroll', 'mousemove'];
  let done = false;
  let timer: ReturnType<typeof setTimeout>;

  const run = () => {
    if (done) return;
    done = true;
    clearTimeout(timer);
    events.forEach(e => window.removeEventListener(e, run));
    callback();
  };

  events.forEach(e => window.addEventListener(e, run, { passive: true, once: true }));
  timer = setTimeout(run, fallbackMs);
}
